import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  uploadDocument,
  deleteDocument,
  renameDocument,
  moveDocument,
} from '@/services/api/documentService';
import { AddFilesResponse } from '@/types/folders/folder';
import { folderKeys } from './useFolders';

export const useUploadDocuments = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ params, data }: { params: any; data: FormData }) => {
      return await uploadDocument(params, data);
    },
    onSuccess: (response: AddFilesResponse, variables: any) => {
      queryClient.invalidateQueries({ queryKey: folderKeys.all });

      if (variables.params?.parent_id) {
        queryClient.invalidateQueries({
          queryKey: folderKeys.list({ folder_id: variables.params.parent_id }),
        });
      } else {
        queryClient.invalidateQueries({
          queryKey: folderKeys.list({}),
        });
      }
    },
  });
};

export const useDeleteDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: any) => {
      return await deleteDocument(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: folderKeys.all });
    },
  });
};

export const useRenameDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: any) => {
      return await renameDocument(params);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: folderKeys.all });
    },
  });
};

export const useMoveDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: any) => {
      return await moveDocument(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: folderKeys.all });
    },
  });
};
